/**
 * Lottieホバーブロック - フロント側
 *
 * 親要素のホバーでアニメーションを再生する。
 * job-templateブロックと同様の実装。
 */
import lottie, { type AnimationItem } from 'lottie-web';

const init = (): void => {
	const items = document.querySelectorAll<HTMLElement>(
		'.wp-block-best-anniversary-blocks-lottie-hover'
	);

	items.forEach((target) => {
		const path = target.dataset.lottie;
		if (!path) {
			return;
		}

		// 親要素を取得（ホバーのトリガー）
		const parent = target.parentElement;
		if (!parent) {
			return;
		}

		const animation: AnimationItem = lottie.loadAnimation({
			container: target,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path,
			rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
		});

		// 親要素のホバーでアニメーション
		parent.addEventListener('mouseenter', () => {
			animation.goToAndPlay(0, true);
		});
		parent.addEventListener('mouseleave', () => {
			animation.goToAndStop(0, true);
		});
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
